import { useState } from "react";

export const useActivate = () => {
const[inProgress, setInProgress] = useState(false)


  return {inProgress, setInProgress};
};
